import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
import Test2 from "./Test2";
// import CustomButt from "../../CustomButton/CustomButt";
import Loader from "../../Loader/Loader";
import NewsCard from "../../AkiyaOnNews/NewsCards/NewsCard";
import CardSlider2 from "../../AkiyaOnNews/NewsCards/customCardSlider";
import { fetchData } from "../../../Utils/CommonFunctions";

// Utility to generate slugs from news headings
const generateSlug = (text) => {
  return text
    ?.toLowerCase()
    .replace(/\s+/g, "-")  // Replace spaces with hyphens
    .replace(/[^\w-]+/g, "") // Remove non-alphanumeric characters
    .replace(/--+/g, "-")     // Replace multiple hyphens with a single one
    .replace(/^-+|-+$/g, ""); // Trim hyphens from start/end
};

function ThirdSOV() {
  const [loading, setLoading] = useState(true);
  const [latestBlogData, setLatestBlogData] = useState([]);
  const [latestNews, setLatestNews] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        const blogResponse = await fetchData("https://app.akiya2.com/blogs");
        const newsResponse = await fetchData("https://app.akiya2.com/all_news");

        const sortedBlogData = blogResponse
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 5);

        // Process news data to ensure all have media_type
        const processedNews = newsResponse.map(item => ({
          ...item,
          // Default to "image" if media_type is not specified
          media_type: item.media_type || "image"
        }));

        setLatestBlogData(sortedBlogData);
        setLatestNews(processedNews);
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false); // Set loading to false in case of error
      }
    };
    fetchDataAsync();
  }, []);

  const firstHeading = "Shimanami Kaido";
  const secondHeading = "A Cyclist's Paradise Over the Seto Inland Sea";
  const paragraph =
    "The Shimanami Kaido (しまなみ海道) is a scenic route connecting Japan's main island of Honshu with the island of Shikoku. Stretching about 70 kilometers, this route is renowned for its breathtaking views and cycling paths that cross multiple islands over a series of impressive bridges. It offers a unique blend of adventure and tranquility, making it a perfect getaway for cyclists and nature enthusiasts alike.";

  return (
    <div className="">
      <div className="flex justify-center">
        <div className="">
          <div className="w-[100vw] flex justify-center items-center">
            <div className="max-w-[1440px] mt-[7rem]">
              <h1 className="dark-header sm:text-left text-center">AKIYA2.0 in the news</h1>
              {loading ? ( // Show loader while data is being fetched
                <Loader />
              ) : (
                <div className="w-full flex items-center justify-center mt-5">
                  <div className="w-[95%]">
                    <CardSlider2
                      data={[...latestNews].reverse()}
                      Card={NewsCard} // Using our updated NewsCard component
                      endValues={{ xs: 1, md: 2, lg: 3 }}
                      renderCard={(newsItem) => {
                        // Generate the slug based on the news heading
                        const slug = generateSlug(newsItem.news_heading);
                        return (
                          <div key={newsItem._id} className="block w-full p-2">
                            <NewsCard item={newsItem} /> {/* Pass the news item to our updated NewsCard */}
                          </div>
                        );
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Second section */}
      <div className="mt-[1rem] mb-[3rem]">
        <div className="mb-[2.5rem]">
          <Test2 />
        </div>
      </div>
    </div>
  );
}

export default ThirdSOV;